import { getLocaleByAlpha2 } from 'country-locale-map'
import {
  CartLineItemFragment,
  MoneyFragment,
  TaxBehavior,
} from './graphql/graphql'

export const centToAmount = (centAmount: number, fractionDigits: number) => {
  return centAmount / 10 ** fractionDigits
}

export const getLineItemTotalPrice = (lineItem: CartLineItemFragment) => {
  if (lineItem.taxBehavior == TaxBehavior.Exclusive && lineItem.taxedPrice) {
    return lineItem.taxedPrice.net
  }

  return lineItem.total
}

export function formatPriceV2(
  country: string,
  money: MoneyFragment,
  digitAmount: number = 0,
): string {
  if (!money || !country) return ''
  let formatter: Intl.NumberFormat
  const amount = centToAmount(money.centAmount, money.fractionDigits)

  if (country?.toUpperCase() === 'INT') {
    const formatter = new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: money.currencyCode,
      currencyDisplay: 'code',
      minimumFractionDigits: digitAmount,
      signDisplay: 'auto',
    })
    return formatter.format(amount)
  }
  const locale = getLocaleByAlpha2(country?.toUpperCase())

  formatter = new Intl.NumberFormat(
    // getLanguageFromCurrency(amount.currencyCode),
    locale.replace('_', '-'),
    {
      style: 'currency',
      currency: money?.currencyCode,
      minimumFractionDigits:
        (money.centAmount / Math.pow(10, money.fractionDigits)) % 1 !== 0
          ? 2
          : digitAmount,
      maximumFractionDigits:
        (money.centAmount / Math.pow(10, money.fractionDigits)) % 1 !== 0
          ? 2
          : digitAmount,
      signDisplay: 'auto',
      // These options are needed to round to whole numbers if that's what you want.
      //minimumFractionDigits: digitAmount, // (this suffices for whole numbers, but will print 25digitAmountdigitAmount.1digitAmount as $2,5digitAmountdigitAmount.1)
      //maximumFractionDigits: digitAmount, // (causes 25digitAmountdigitAmount.99 to be printed as $2,5digitAmount1)
    },
  )

  // USD = 599 -> 59900
  // KOR = 599 -> 599
  //USD: 59900 = 599.00
  //KOR: 599 = 599
  //how do i calculate centAmount to amount, so if i have 599digitAmountdigitAmount centAmount, i get 599.digitAmountdigitAmount amount?
  return formatter?.format(
    parseFloat(
      (money.centAmount / Math.pow(10, money.fractionDigits)).toFixed(
        money.fractionDigits,
      ),
    ),
  )
}

export const centAmountToAmountV2 = (amount: {
  centAmount: number
  fractionDigits: number
  currencyCode: string
}) => {
  if (!amount) return 0
  return parseFloat(
    (amount.centAmount / Math.pow(10, amount.fractionDigits)).toFixed(
      amount.fractionDigits,
    ),
  )
}

const getLanguageFromCurrency = (currency: string) => {
  switch (currency) {
    case 'USD':
      return 'en-US'
    case 'EUR':
      return 'en-US'
    case 'GBP':
      return 'en-GB'
    case 'DKK':
      return 'da-DK'
  }
}
